"use client";

import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { ApiQuotedDrop } from "@/generated/models/ApiQuotedDrop";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { useEffect, useState } from "react";
import type { ApiDropPart } from "@/generated/models/ApiDropPart";
import DropPart from "@/components/drops/view/part/DropPart";
import { DropPartSize } from "@/components/drops/view/part/DropPart.types";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiDropGroupMention } from "@/generated/models/ApiDropGroupMention";
import type { ApiDropReferencedNFT } from "@/generated/models/ApiDropReferencedNFT";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
import type { ProfileMinWithoutSubs } from "@/helpers/ProfileTypes";
import { DROP_DETAIL_STALE_TIME_MS, fetchDropByIdBatched, getDropQueryKey } from "@/services/api/drop-api";
interface PartConfigWave {
  readonly name: string;
  readonly image: string | null;
  readonly id: string;
}
interface PartConfig {
  readonly dropId: string;
  readonly part: ApiDropPart;
  readonly mentionedUsers: Array<ApiDropMentionedUser>;
  readonly mentionedGroups: Array<ApiDropGroupMention>;
  readonly mentionedWaves: Array<ApiMentionedWave>;
  readonly referencedNfts: Array<ApiDropReferencedNFT>;
  readonly createdAt: number;
  readonly wave: PartConfigWave;
  readonly dropTitle: string | null;
}
export default function CreateDropStormViewPartQuote(t0) {
  const $ = _c(23);
  const {
    profile,
    quotedDrop
  } = t0;
  const quotedDropId = quotedDrop.drop_id;
  let t1;
  if ($[0] !== quotedDropId) {
    t1 = getDropQueryKey(quotedDropId);
    $[0] = quotedDropId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] !== quotedDropId) {
    t2 = () => fetchDropByIdBatched(quotedDropId);
    t3 = quotedDropId.trim();
    $[2] = quotedDropId;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  const t4 = t3.length > 0;
  let t5;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t4) {
    t5 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t4,
      placeholderData: keepPreviousData,
      staleTime: DROP_DETAIL_STALE_TIME_MS
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    data: drop
  } = useQuery(t5);
  let t6;
  if ($[9] !== drop || $[10] !== quotedDrop.drop_part_id) {
    t6 = () => {
      if (!drop) {
        return null;
      }
      const part_0 = drop.parts.find(part => part.part_id === quotedDrop.drop_part_id);
      if (!part_0) {
        return null;
      }
      return {
        dropId: drop.id,
        part: part_0,
        mentionedUsers: drop.mentioned_users,
        mentionedGroups: drop.mentioned_groups,
        mentionedWaves: drop.mentioned_waves,
        referencedNfts: drop.referenced_nfts,
        createdAt: drop.created_at,
        dropTitle: drop.title,
        wave: {
          name: drop.wave.name,
          image: drop.wave.picture,
          id: drop.wave.id
        }
      };
    };
    $[9] = drop;
    $[10] = quotedDrop.drop_part_id;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const getPartConfig = t6;
  let t7;
  if ($[12] !== getPartConfig) {
    t7 = () => getPartConfig();
    $[12] = getPartConfig;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const [partConfig, setPartConfig] = useState(t7);
  let t8;
  if ($[14] !== getPartConfig) {
    t8 = () => setPartConfig(getPartConfig());
    $[14] = getPartConfig;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== drop) {
    t9 = [drop];
    $[16] = drop;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  useEffect(t8, t9);
  let t10;
  if ($[18] !== partConfig || $[19] !== profile) {
    t10 = !!partConfig && <DropPart dropId={partConfig.dropId} profile={profile} mentionedUsers={partConfig.mentionedUsers} mentionedGroups={partConfig.mentionedGroups} mentionedWaves={partConfig.mentionedWaves} referencedNfts={partConfig.referencedNfts} smallMenuIsShown={false} partContent={partConfig.part.content ?? null} partMedias={partConfig.part.media.map(_temp)} createdAt={partConfig.createdAt} wave={partConfig.wave} dropTitle={partConfig.dropTitle} size={DropPartSize.SMALL} />;
    $[18] = partConfig;
    $[19] = profile;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10) {
    t11 = <div className="tw-mt-2 tw-w-full tw-rounded-lg tw-border tw-border-solid tw-border-iron-700 tw-p-2">{t10}</div>;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}
function _temp(media) {
  return {
    mimeType: media.mime_type,
    mediaSrc: media.url
  };
}